//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import InputText from '@/components/wp/InputText'
import TextArea from '@/components/wp/TextArea'
import ButtonGroup from '@/components/wp/ButtonGroup'
import GoogleMaps from '../../components/general/GoogleMaps'

export default {
    metaInfo: {
        meta: [
            {charset: 'utf-8'},
            {
                name: 'viewport',
                content:
                    'width=device-width, initial-scale=1, user-scalable=no',
            },
        ],
    },
    props: ['generalData', 'menu', 'cartSettings'],
    data() {
        return {
            selectedCategory: null,
            orderNo: '',
            selectedItemIndex: 0,
            seamless: false,
            selectedItem: {},
            pickupMethods: [
                {label: 'Delivery', value: 'Delivery'},
                {label: 'Retirar en local', value: 'Retirar en local'},
            ],
            selectedPickupMethod: '',
            address: '',
            total: 0,
            location: [],
            markers: [],
            center: {},
            optionsDialog: false,
            stylesDialog: false,
            sideDialog: false,
            successDialog: false,
            cartDialog: false,
            cart: [],
        }
    },
    methods: {
        updateValue(e) {
            this.cartSettings.inputData[e.index].value = e.value
        },
        returnMinVal(options){
            let min = options[0].price
            options.forEach(op => {
                if (op.price < min)
                    min = op.price
            })
            return min.toFixed(2)
        },
        addItemToCart() {
            if (!this.checkIfDuplicate()) {
                this.selectedItem.amount = 1
                this.cart.push(this.selectedItem)
                this.optionsDialog = false
                this.successDialog = true
                this.calculateTotal()
            } else {
                this.cart.forEach(c => {
                    if (
                        c.type === this.selectedItem.type &&
                        c.title === this.selectedItem.title &&
                        c.options.title === this.selectedItem.options.title &&
                        c.styles.title === this.selectedItem.styles.title &&
                        c.sides.title === this.selectedItem.sides.title
                    ) {
                        c.amount++
                    }
                })
                this.optionsDialog = false
                this.successDialog = true
                this.calculateTotal()
            }
        },
        handleDialogs(section, item) {
            //option, style, side
            if (section === 'option') {
                this.selectedItem.options = item
                this.optionsDialog = false
                if (this.menu[this.selectedItemIndex].styles.length > 0) {
                    this.stylesDialog = true
                } else {
                    this.addItemToCart()
                }
            }
            if (section === 'style') {
                this.selectedItem.styles = item
                this.stylesDialog = false
                if (this.menu[this.selectedItemIndex].sides.length > 0) {
                    this.sideDialog = true
                } else {
                    this.addItemToCart()
                }
            }
            if (section === 'side') {
                this.sideDialog = false
                this.selectedItem.sides = item
                this.addItemToCart()
            }
        },
        selectItem(item) {
            let itemInMenu = this.menu.filter((m, index) => {
                if (m.title === item.title) {
                    this.selectedItemIndex = index
                    return m
                }
            })
            this.selectedItem = JSON.parse(
                JSON.stringify(this.menu[this.selectedItemIndex])
            )
            this.optionsDialog = true
        },
        checkIfDuplicate() {
            let isDuplicate = false
            if (this.cart.length <= 0) {
                isDuplicate = false
            }

            this.cart.forEach(c => {
                if (
                    c.type === this.selectedItem.type &&
                    c.title === this.selectedItem.title &&
                    c.options.title === this.selectedItem.options.title &&
                    c.styles.title === this.selectedItem.styles.title
                ) {
                    isDuplicate = true
                }
            })
            return isDuplicate
        },
        removeItemFromCart(i) {
            this.cart.splice(i, 1)
        },
        calculateTotal() {
            let total = 0
            this.cart.forEach(c => {
                if (c.price) total += c.price * c.amount
                if (c.options.price) total += c.options.price * c.amount
                if (c.styles.price) total += c.styles.price * c.amount
                if (c.sides.price) total += c.sides.price * c.amount
            })
            this.total = total
        },
        generateMessage() {
            let message =
                'Buenas me gustaria realizar un pedido de:%0D%0A%0D%0A'
            for (let item of this.cart) {
                message += `- (${item.amount}) ${item.title} - ${item.options.title}`
                if (item.styles.title != undefined) {
                    message += ` - ${item.styles.title}`
                }
                if (item.sides.title != undefined) {
                    message += ` - ${item.sides.title}`
                }
                message += `%0D%0A`
            }
            this.cartSettings.inputData.forEach(input => {
                if (input.value != undefined)
                    message += `%0D%0A${input.label}: ${input.value}`
            })
            message += `%0D%0AMetodo de entrega: ${this.selectedPickupMethod}`
            if (this.selectedPickupMethod == 'Delivery') {
                message += `%0D%0AUbicacion: ${this.getLocationForMessage()}%0D%0ADireccion: ${
                    this.address
                }`
            }
            message += `%0D%0ANo. de pedido: ${this.orderNo}`
            message += `%0D%0ATotal: $ ${this.total.toFixed(2)}`
            message = message.replace(/\+/g, '%2B')
            message = message.replace(/&/g, '%26')
            message = message.replace(/#/g, '%23')
            return message
        },
        async sendToGoogleDriveSheet() {
            let message = ''
            for (let item of this.cart) {
                message += `- (${item.amount}) ${item.title} - ${item.options.title}`
                if (item.styles.title != undefined) {
                    message += `- ${item.styles.title}`
                }
                if (item.sides.title != undefined) {
                    message += `- ${item.sides.title}`
                }
                message += `\n`
            }
            let data = {
                id: this.orderNo,
                pedido: message,
                status: 'orden creada',
                total: this.total,
                metodo_de_entrega: this.selectedPickupMethod,
            }
            if (data.metodo_de_entrega === 'Delivery') {
                data.direcion_1 = this.getLocationForMessage()
                data.direcion_2 = this.address
            }
            this.cartSettings.inputData.forEach(input => {
                let key = input.label.toLowerCase()
                key = key.replace(/\s/g, '_')
                if (input.value != undefined)
                    data[key] = input.value
                else
                    data[key] = ''
            })
            var url = this.generalData.googleSheets.url
            var xhr = new XMLHttpRequest()
            xhr.open('POST', url)
            // xhr.withCredentials = true;
            xhr.setRequestHeader(
                'Content-Type',
                'application/x-www-form-urlencoded'
            )
            // url encode form data for sending as post data
            var encoded = Object.keys(data)
                .map(function (k) {
                    return (
                        encodeURIComponent(k) +
                        '=' +
                        encodeURIComponent(data[k])
                    )
                })
                .join('&')
            await xhr.send(encoded)
        },
        getLocationForMessage() {
            if (this.location.length === 0) {
                if (
                    parseFloat(this.center.lat) ===
                        parseFloat(this.cartSettings.locationDefaults.defaultLat) &&
                    parseFloat(this.center.lng) === parseFloat(this.cartSettings.locationDefaultsdefaultLng)
                ) {
                    return `>> Pedir Ubicacion !!`
                } else {
                    if (this.generalData.wazeIntegration == false) {
                        if (this.center.lat < 0)
                            this.center.lng = `+${this.center.lng}` //Google Maps
                        if (this.center.lng < 0)
                            this.center.lng = `+${this.center.lng}` //Google Maps
                        return `https://www.google.com/maps?q=${this.center.lat},${this.center.lng}`
                    } else {
                        return `https://waze.com/ul?ll=${this.center.lat},${this.center.lng}&z=10`
                    }
                    
                    
                }
            } else {
                let lat = parseFloat(this.location.lat)
                let lng = parseFloat(this.location.lng)
                if (lat === NaN || lng === NaN) return `>> Pedir Ubicacion !!`
                if (this.generalData.wazeIntegration == false) {
                    if (lat < 0) lat = `+${lat}` //Google Maps
                    if (lng < 0) lng = `+${lng}` //Google Maps
                    return `https://www.google.com/maps?q=${lat},${lng}`
                } else {
                    return `https://waze.com/ul?ll=${lat},${lng}&z=10`
                }
            }
        },
        setMarkerPosition(event) {
            this.location = event
        },
        geolocate() {
            navigator.geolocation.getCurrentPosition(
                position => {
                    this.center = {
                        lat: parseFloat(position.coords.latitude),
                        lng: parseFloat(position.coords.longitude),
                    }
                    this.markers.push({position: this.center})
                },
                error => {
                    this.center = {
                        lat: parseFloat(this.cartSettings.locationDefaults.defaultLat),
                        lng: parseFloat(this.cartSettings.locationDefaults.defaultLng),
                    }
                    this.markers.push({position: this.center})
                }
            )
        },
        async sendChat() {
            for (let input of this.cartSettings.inputData) {
                if (input.required == true && (input.value == undefined || input.value == '')) {
                    alert(`Debes ingresar la siguiente informacion:\n\n${input.label}`)
                    return
                }
            }
            if (this.selectedPickupMethod == '') {
                alert('Debes seleccionar un metodo de entrega.')
                return
            } 
            if (this.selectedPickupMethod == 'Delivery' && this.address == '') {
                alert('Debes ingresar tu direccion completa para la entrega de tu pedido.')
                return
            }else {
                this.orderNo = Math.floor(100000 + Math.random() * 900000)
                this.$analytics.logEvent(`wp-${this.generalData.folder}`, {
                    content_action: 'Orden Completada',
                })
                if (this.generalData.googleSheets.integration == true)
                    await this.sendToGoogleDriveSheet()
                window.location.href = `https://wa.me/507${
                    this.generalData.whatsappNumber
                }?text=${this.generateMessage()}`
            }
        },
    },
    computed: {
        filterMenuItems() {
            let items = []
            if (this.selectedCategory == null || this.selectedCategory == 'Todo')
                return this.menu
            this.menu.forEach(item => {
                if (item.type == this.selectedCategory) {
                    items.push(item)
                }
            })
            return items
        }
    },
    watch: {
        cart() {
            this.calculateTotal()
            if (this.cart.length > 0) {
                this.seamless = true
                this.$store.commit('SET_DISPLAYFOOTER', true)
            } else {
                this.seamless = false
                this.$store.commit('SET_DISPLAYFOOTER', false)
            }
        },
    },
    components: {
        GoogleMaps,
        InputText,
        TextArea,
        ButtonGroup
    },
    mounted() {
        this.generalData.categories.push('Todo')
        if (this.$hj) {
            this.$hj('vpv', 'funnel-step-one')
        }
        this.$store.commit('SET_DISPLAYFOOTER', false)
        let path = this.$route.params.path
        this.$analytics.logEvent(`wp-${this.generalData.folder}`, {
            path,
        })
        this.geolocate()
    },
}
